import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { ImageCarouselComponent } from './image-carousel.component';
import { CarouselModule } from 'outshared-lib';
import { LazyLoadImageModule } from 'ng-lazyload-image';

@NgModule({
    imports: [
        CommonModule,
        CarouselModule,
        LazyLoadImageModule,
    ],
    exports: [
        ImageCarouselComponent
    ],
    declarations: [
        ImageCarouselComponent
    ]
})
export class ImageCarouselModule { }
